import { render, staticRenderFns } from "./Ddt.vue?vue&type=template&id=36c64dd3&scoped=true"
import script from "./Ddt.vue?vue&type=script&lang=js"
export * from "./Ddt.vue?vue&type=script&lang=js"
import style1 from "./Ddt.vue?vue&type=style&index=1&id=36c64dd3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36c64dd3",
  null
  
)

export default component.exports